export const cast = {
  nova: {
    name: "Nova",
    role: "Curious trail guide",
    image: "/brand/puzzle-guide-small.png",
    sceneImage: "/learning/story/nova-full.png",
  },
  milo: {
    name: "Milo",
    role: "Otter maker who tries and checks",
    image: "/learning/story/milo.png",
    sceneImage: "/learning/story/milo-full.png",
  },
  junie: {
    name: "Junie",
    role: "Rabbit pattern finder",
    image: "/learning/story/junie.png",
    sceneImage: "/learning/story/junie-full.png",
  },
} as const;
export const TEAM_CHAPTER = {
  id: "grade1-team",
  name: "Make a Team",
  place: "Picnic Bridge",
  tagline: "A picnic. A mystery bag. Three friends who figure it out.",
  topics: ["g1_team_join", "g1_team_missing", "g1_team_balance"],
  labels: ["Join the teams", "Find the hidden part", "Make teams match"],
  minutes: "10–15 minutes",
  panels: [
    {
      who: "nova",
      text: "Our picnic is across the creek. Let’s bring our things together!",
      scene: "welcome",
    },
    {
      who: "milo",
      text: "I brought 3 things. Touch each one as you count.",
      scene: "three",
    },
    {
      who: "junie",
      text: "I brought 4 things. How many will we have together?",
      scene: "four",
    },
    {
      who: "nova",
      text: "Start with Junie’s larger team of 4. Count on 3: 5, 6, 7. Nice! 4 and 3 make 7.",
      scene: "join",
    },
    {
      who: "milo",
      text: "We have 7 things. I can see my 3. What is hiding in Junie’s bag?",
      scene: "missing",
    },
    {
      who: "junie",
      text: "The hidden part is 4. Two parts make one whole. 3 and 4 make 7!",
      scene: "bond",
    },
    {
      who: "nova",
      text: "3 and 4 make 7. 5 and 2 make 7 too. The same total means equal. Your turn!",
      scene: "balance",
    },
  ],
} as const;
export type CastId = keyof typeof cast;
export type TeamScene = (typeof TEAM_CHAPTER.panels)[number]["scene"];
